import React, { PureComponent } from 'react';
import AppMenuContainer from '../AppMenu/AppMenuContainer';
import UserInfoContainer from '../UserInfo/UserInfoContainer';
import AlertsDrawerContainer from '../AlertsDrawer/AlertsDrawerContainer';
import Logo from '../Logo/Logo';
import OnlineHelp from '../OnlineHelp/OnlineHelp';
import PermissionsCheck from '../PermissionsCheck/PermissionsCheck';
import PermissionsEnum from '../../constants/PermissionsEnum';

import './AppHeader.css';

class AppHeader extends PureComponent {
  render() {
    return (
      <header
        data-qa="app-header"
        className="u-fx u-fx-align-center u-fx-space-between u-ph-full u-pv-half"
      >
        <div className="u-fx u-fx-align-center">
          <AppMenuContainer />
          <Logo />
        </div>
        <div className="u-fx u-fx-align-center">
          <div className="header-online-help">
            <OnlineHelp isHelpRoot={true} />
          </div>
          <UserInfoContainer />
          <AlertsDrawerContainer />
        </div>
      </header>
    );
  }
}

export default AppHeader;
